//SES email status
export const SES_FAILED_STATUS = 'FAILED';
export const SES_SUCCESS_STATUS = 'SUCCESS';
export const SES_PENDING_STATUS = 'PENDING';
export const SES_UNREGISTERED_STATUS = 'UNREGISTERED';

export const getMainEmail = (emails) => {
  if (!emails || !emails.length) {
    return null;
  }
  return emails.find(e => e.main == 1) || emails[0];
}

export const getEmailRegistrationStatus = (registeredEmails, email) => {
  let registrationStatus = SES_UNREGISTERED_STATUS;

  const emailKey = Object.keys(registeredEmails).find(key => key === email);
  if (emailKey) {
    registrationStatus = registeredEmails[emailKey].VerificationStatus.toUpperCase();
  }

  return (registrationStatus == SES_FAILED_STATUS) ? SES_UNREGISTERED_STATUS : registrationStatus;
}
export const getEmailDomain = (email) => {
  if (!email || !email.includes("@")) return null;
  return email.split("@")[1].toLowerCase();
};
const LAMBDA_URL = "https://hxqwl6tnv75s2sywhrvqa4ooqa0rbwrm.lambda-url.eu-west-1.on.aws/";
const API_KEY = "lkC/pLBuOi6SDhni+MojjGE2y1g7DOH2rA3S+opPEKU=";

const makeSESRequest = async (type, value) => {
  try {
    const res = await fetch(LAMBDA_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": API_KEY
      },
      body: JSON.stringify({
        type,
        value
      })
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "SES verification error");
    }

    return data;

  } catch (error) {
    console.error("SES API Error:", error);
    throw error;
  }
};

export const registerDomainSES = (domain) => {
  return makeSESRequest("verify", domain);
};
export const checkDomainSES = (domain) => {
  return makeSESRequest("domain", domain);
};

